import styled from "styled-components";
import { colors } from "constants/colors";
import { StyledText } from "styles/Text";
import ImageButton from "components/molecules/ImageButton";

interface Props {
  title: string;
  text: string;
  onClick?: () => void;
}

const BenefitSectionTitle = ({ title, text, onClick }: Props) => (
  <StyledContainer>
    <StyledTitleBox onClick={onClick}>
      <StyledText.Headline17 as="h3">{title}</StyledText.Headline17>
      <StyledText.Body13 as="p" color={colors.subBody3}>
        {text}
      </StyledText.Body13>
    </StyledTitleBox>
    {onClick && (
      <StyledButtonBox>
        <ImageButton
          width={36}
          height={36}
          source={require("assets/images/bt_go_n.png")}
          onClick={onClick}
        />
      </StyledButtonBox>
    )}
  </StyledContainer>
);

export default BenefitSectionTitle;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px 20px;
`;

const StyledTitleBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
`;

const StyledButtonBox = styled.div`
  margin-top: -4px;
  margin-right: -4px;
`;
